import { render, staticRenderFns } from "./HelpBell.vue?vue&type=template&id=9560a630&"
import script from "./HelpBell.vue?vue&type=script&lang=js&"
export * from "./HelpBell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports